import { lmsClient } from "api";
import dummyJurnalTemplate from "./dummyJurnalTemplate";

// Flip to false once the real `/lms/JurnalTemplate/*` endpoints exist on the
// backend — every method below already mirrors the axios `{ status, data }`
// response shape the real lmsClient calls return, so callers (the slice,
// the pages) never need to change, only this flag.
const USE_DUMMY_DATA = true;

let dummyStore = dummyJurnalTemplate.map((item) => ({
  ...item,
  postingRules: item.postingRules.map((rule) => ({ ...rule })),
}));

const delay = (ms = 300) => new Promise((resolve) => setTimeout(resolve, ms));

const nextDummyId = () =>
  dummyStore.reduce((max, item) => Math.max(max, item.id), 0) + 1;

const nextPostingRuleId = () =>
  dummyStore.reduce(
    (max, item) => Math.max(max, ...item.postingRules.map((rule) => rule.id), 0),
    0
  ) + 1;

const buildJurnalTemplateParams = (data = {}) => {
  const params = new URLSearchParams();
  params.append("code", data.code || "");
  params.append("tablename", data.tablename || "");
  params.append("queryBuilderId", data.queryBuilderId || "");
  params.append("pageIndex", data.pageIndex ?? 0);
  params.append("pageSize", data.pageSize ?? 1000);
  return params.toString();
};

const JurnalTemplateService = {};

JurnalTemplateService.getJurnalTemplateList = function (data = {}) {
  
  
  return lmsClient({
    url: `/lms/GlJournalQueryBuilder/search?${buildJurnalTemplateParams(data)}`,
    method: "get",
  });
};

JurnalTemplateService.getJurnalTemplateById = function (id) {
  if (USE_DUMMY_DATA) {
    const found = dummyStore.find((item) => item.id === id) || null;
    return delay().then(() => ({ status: 200, data: found }));
  }

  return lmsClient({
    url: `/lms/JurnalTemplate/${id}`,
    method: "get",
  });
};

JurnalTemplateService.addJurnalTemplate = function (data) {
  if (USE_DUMMY_DATA) {
    const id = nextDummyId();
    const now = new Date().toISOString();
    let nextRuleId = nextPostingRuleId();
    const newItem = {
      id,
      ...data,
      postingRules: (data.postingRules || []).map((rule, index) => ({
        id: nextRuleId++,
        seq: index + 1,
        ...rule,
        createdBy: "system",
        createdDate: now,
        updatedBy: "system",
        updatedDate: now,
      })),
      createdBy: "system",
      createdDate: now,
      updatedBy: "system",
      updatedDate: now,
    };
    dummyStore = [newItem, ...dummyStore];

    return delay().then(() => ({
      status: 200,
      data: {
        status: "Success",
        message: "Jurnal template berhasil ditambahkan",
        data: newItem,
      },
    }));
  }

  return lmsClient({
    url: `/lms/JurnalTemplate/add`,
    method: "post",
    headers: {},
    data,
  });
};

JurnalTemplateService.updateJurnalTemplate = function (data) {
  if (USE_DUMMY_DATA) {
    const { id, ...requestBody } = data;
    const now = new Date().toISOString();
    let nextRuleId = nextPostingRuleId();
    let updated = null;
    dummyStore = dummyStore.map((item) => {
      if (item.id === id) {
        updated = {
          ...item,
          ...requestBody,
          postingRules: (requestBody.postingRules || []).map((rule, index) => ({
            id: rule.id || nextRuleId++,
            seq: index + 1,
            ...rule,
            updatedBy: "system",
            updatedDate: now,
          })),
          updatedAt: now,
          updatedBy: "system",
          updatedDate: now,
        };
        return updated;
      }
      return item;
    });

    return delay().then(() => ({
      status: 200,
      data: {
        status: updated ? "Success" : "Error",
        message: updated ? "Jurnal template berhasil diperbarui" : "Jurnal template tidak ditemukan",
        data: updated,
      },
    }));
  }

  const { id, ...requestBody } = data;
  return lmsClient({
    url: `/lms/JurnalTemplate/edit`,
    method: "put",
    headers: { "x-requestId": id },
    data: requestBody,
  });
};

JurnalTemplateService.deleteJurnalTemplate = function (data) {
  if (USE_DUMMY_DATA) {
    const before = dummyStore.length;
    dummyStore = dummyStore.filter((item) => item.id !== data.id);
    const deleted = dummyStore.length < before;

    return delay().then(() => ({
      status: 200,
      data: {
        status: deleted ? "Success" : "Error",
        message: deleted ? "Jurnal template berhasil dihapus" : "Jurnal template tidak ditemukan",
      },
    }));
  }

  return lmsClient({
    url: `/lms/JurnalTemplate/delete`,
    method: "delete",
    headers: { "x-requestId": data.id },
    data,
  });
};

export default JurnalTemplateService;
